import { Component, OnInit } from '@angular/core';
import { MDBModalRef,MDBModalService } from 'angular-bootstrap-md';
import { Subject } from 'rxjs';


import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { MaeUsuarioService } from 'src/app/service/mae-usuario.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';
import { DetFirmanteService } from 'src/app/service/det-firmante.service';

import { MaeUsuarioM } from 'src/app/model/mae-usuario-bean';
import { DetFirmanteE} from 'src/app/model/det-firmante-bean'
import { Response_dml_bean } from 'src/app/model/response-dml';

@Component({
  selector: 'app-add-firmante',
  templateUrl: './add-firmante.component.html',
  styleUrls: ['./add-firmante.component.scss']
})

export class AddFirmanteComponent implements OnInit {
  constructor(
    public  modalRefFirmanteDml: MDBModalRef,
    private globalVariablesService:GlobalVariablesService,
    private maeUsuarioService:MaeUsuarioService,
    private detFirmanteService:DetFirmanteService,
    private utilitarioService:UtilitarioService,
  ){}

  detFirmanteE = new DetFirmanteE();
  listUsuarios = new Array<MaeUsuarioM>();

  //variables enviado desde el padre
  x_titulo:String;
  id_constancia:String;
  n_secuencia:Number;

  x_oficina:String;
  id_usuario_existe:number;

  //action del padre para el retorno de datos
  action: Subject<Response_dml_bean> = new Subject();

  ngOnInit(): void {

    this.utilitarioService.loading = true;
    this.detFirmanteE.c_usuario = 0;
    this.detFirmanteE.c_oficina = 0;


    var estado = "3";
    this.maeUsuarioService.getfindFirma(estado).subscribe(data=>{
      if(this.id_usuario_existe>0)
        this.listUsuarios = data.filter(val => val.c_usuario != this.id_usuario_existe);
      else
        this.listUsuarios = data;
      this.utilitarioService.loading = false;
    });

  }
  onClosemodal(){
    this.modalRefFirmanteDml.hide();
  }
  onUsuarioChange()
  {
    var id_user = this.detFirmanteE.c_usuario;
    var resul = this.listUsuarios.filter(val => val.c_usuario == id_user);
    if(resul.length>0)
    {
      this.detFirmanteE.c_oficina = resul[0].c_oficina;
      this.x_oficina = resul[0].x_oficina;
    }
    else
      this.x_oficina = "";
  }
  onGrabar(){
    if (this.validarFormulario()==false){
      return false;
    }

    this.detFirmanteE.auditoriaBeanM = this.globalVariablesService.getAuditoriaServicio("I");
    this.detFirmanteE.serviceCredencialesM=this.globalVariablesService.getCredencialesConvenio();
    this.detFirmanteE.c_constancia = Number(this.id_constancia);
    this.detFirmanteE.n_secuencia = this.n_secuencia;

    this.utilitarioService.loading=true;

    this.detFirmanteService.insert(this.detFirmanteE).subscribe((response_dml_bean:Response_dml_bean)=>{

      this.utilitarioService.loading=false;
      this.action.next(response_dml_bean);
      this.modalRefFirmanteDml.hide();

    });
  }
  validarFormulario(){
    //valida formulario
    if (this.globalVariablesService.getC_usuario.toString()==null){
      this.utilitarioService.toastrError("Su session ha culminado, ingrese nuevamente al sistema.");
      return false;
    }

    if (this.detFirmanteE.c_usuario==0){
      this.utilitarioService.toastrError("Seleccione un usuario.");
      return false;
    }

    return true;
  }
}
